import { Block, DocumentIntake } from "generated/graphql";
import { FormFieldValuesUI } from "Backend";
import { P } from "theme/typography";
import { useAppSelector } from "redux/hooks";
import IntakeViewer from "components/DocumentViewer/IntakeViewer";
import { selectIntakeById } from "redux/slices/case";

interface Props {
  lensId: number;
  caseId: number;
  intakeId: number;
  onFormUpdate?: () => Promise<FormFieldValuesUI[] | undefined>;
  knownFieldId?: number;
  showPinToPageForm?: boolean;
  canShowAllHits?: boolean;
  canPinFromViewer?: boolean;
  defaultShowHighlightLensHits?: boolean;
  immediatePinToValueGroup: (block: Block) => void;
  blockIndex?: number | null;
  pageNumState: [page: number, setPage: (value: number) => void];
  className?: string;
}

const CaseFormIntake = (props: Props) => {
  const {
    className,
    lensId,
    caseId,
    intakeId,
    onFormUpdate,
    knownFieldId,
    canShowAllHits,
    canPinFromViewer,
    defaultShowHighlightLensHits,
    immediatePinToValueGroup,
    blockIndex,
    pageNumState,
  } = props;
  const intake: DocumentIntake | undefined = useAppSelector(selectIntakeById(intakeId));

  return (
    <div className="flex w-full h-full grow">
      {intake ? (
        <IntakeViewer
          lensId={lensId}
          canPin={canPinFromViewer}
          canShowAllHits={canShowAllHits}
          caseId={caseId}
          intake={intake}
          pageNumberHandle={pageNumState}
          parentBlockIndex={blockIndex}
          additionalAnnotations={[]}
          onFormUpdate={onFormUpdate}
          knownFieldId={knownFieldId}
          ignoreExistingBlocksForPinning
          defaultShowHighlightLensHits={defaultShowHighlightLensHits}
          immediatePinToValueGroup={immediatePinToValueGroup}
          canPinFullPage
          pinForm={{
            mode: "panel",
            cardFormFragmentProps: {
              compact: true,
            },
          }}
          className={className}
        />
      ) : (
        <P>Loading Document</P>
      )}
    </div>
  );
};

export default CaseFormIntake;
